module.exports = __webpack_public_path__ + "img/Looks10.de8fac60.jpg";